// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Card_wrapper__3Xt4g"};